/*
 * $Id:: request.js 2021/01/15 04:15 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { getLoginUrl } from '../../providers';
import ApiError from '../ApiError';

const apiPrefix = '/api/v1';

const CSRF_HEADER_NAME = 'X-CSRF-HEADER-NAME';
let csrfHeaderName = null;
let csrfToken = null;

const checkCsrfHeaders = (response) => {
    let auxCsrfHeaderName = response.headers.get(CSRF_HEADER_NAME);
    if (auxCsrfHeaderName) {
        let auxCsrfToken = response.headers.get(auxCsrfHeaderName);
        if (auxCsrfToken) {
            csrfToken = auxCsrfToken;
            csrfHeaderName = auxCsrfHeaderName;
        }
    }
};

const apiParams = (body, type = 'POST', additionalHeaders = {}, includeCsrf = true) => {
    let headers = {
        'Content-Type': 'application/json',
        ...additionalHeaders,
    };

    if (csrfToken && includeCsrf) {
        headers[csrfHeaderName] = csrfToken;
    }
    const isApplicationJson = headers['Content-Type'] === 'application/json';
    const isMultiPartFormData = headers['Content-Type'] === 'multipart/form-data';

    let requestBody = body;
    if (isApplicationJson) {
        requestBody = JSON.stringify(body);
    } else if (isMultiPartFormData) {
        delete headers['Content-Type'];
        requestBody = new FormData();
        for (let key in body) {
            // when we upload attachments we cannot stringify the form data
            // also workaround for when we have list of files instead of FileList
            if (body[key] instanceof FileList || 'files' === key) {
                body[key].forEach((file) => {
                    requestBody.append(key, file);
                });
            } else {
                requestBody.append(key, body[key]);
            }
        }
    }

    return {
        method: type, // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache',
        credentials: 'same-origin',
        headers,
        body: requestBody,
    };
};

const sendRequest = ({ url, method, body, prefix = null, headers = {}, noResponse = false, doNotRedirect = false, returnJSON = true }) => {
    let code;
    const includeCsrf = true;
    return fetch(`${prefix || apiPrefix}${url}`, apiParams(body, method, headers, includeCsrf))
        .then((res) => {
            code = res.status;
            if (includeCsrf) {
                checkCsrfHeaders(res);
            }
            if (code === 401 && !doNotRedirect) {
                // Intercept call to empty cached user, if any, and redirect to login page.
                // window.location.replace(`${apiHost}:${apiPort}`);
                const loginUrl = getLoginUrl();
                window.location.replace(loginUrl);
            }
            if (code === 404) {
                //workaround when user session is destroyed on server side due to username-change
                if(url === '/auth/me' ||
                    url === '/account/details'){
                    const loginUrl = getLoginUrl();
                    window.location.replace(loginUrl);
                }
                throw new ApiError({ code, message: 'something.not.found' });
            }
            if(code === 500) {
                throw new ApiError({ code, message: 'something.went.wrong' });
            }
            if (code === 403) return res.json();
            if (noResponse) return {};
            if (returnJSON) return res.json();
            return res;
        })
        .then((response) => {
            if ((response.code && response.code > 399) || code > 399) throw new ApiError({ ...response, code });
            return response;
        });
};

export { sendRequest, apiParams };
